import { render, staticRenderFns } from "./FormAssinatura.vue?vue&type=template&id=a04a6f7e"
import script from "./FormAssinatura.vue?vue&type=script&lang=js"
export * from "./FormAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports